import * as React from "react";
import { Permission } from "webportalclient";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";
import LoadingWithMessage from "../../misc/components/LoadingWithMessage";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const RolePermissionsOverview = () => {
    const client = useWebPortalApiClient();
    const [permissions, setPermissions] = React.useState<Permission[]>();
    const { study } = useCurrentStudyConfigurationContext();

    React.useEffect(() => {
        const getData = async () => {
            const permissionResult = await client.client.getPermissions("id,name,roles", `roles/any(r: r/studyId eq ${study.id})`, 'name', 'roles($select=id,studyId,name)');

            setPermissions(permissionResult.value);
        }
        getData();
    }, []);

    if (permissions === undefined)
        return <LoadingWithMessage message="Loading Permissions..." />

    if (permissions.length === 0)
        return <Alert show={true} category={AlertCategoryEnum.Info}>There are no roles for this study</Alert>

    return (
        <div className="panel panel-default">
            <div className="panel-body">
                <table className="table table-striped table-bordered table-hover">
                    <thead>
                        <tr>
                            <th>Permission</th>
                            <th>Roles</th>
                        </tr>
                    </thead>
                    <tbody>
                        {permissions.map(pc => (
                            <tr key={pc.id}>
                                <td>
                                    {pc.name}
                                </td>
                                <td>
                                    {pc.roles.filter(r => r.studyId === study.id).map(r => (
                                        <div key={r.id} className="col-lg-3 col-md-4 col-sm-6">
                                            <FontAwesomeIcon icon={faUser} /> {r.name}
                                        </div>
                                    ))}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}
